<script lang="ts">
	import { Assets } from './game/Assets';
	import PlayScreen from './ui/play-screen/PlayScreen.svelte';

	const readyPromise = ( async () => {
		await Assets.load();
	} )();
</script>

{#await readyPromise}
	Loading....
{:then}
	<PlayScreen />
{:catch error}
	Error: { error.message }
{/await}
